<template>
  <div id="tab1" v-if="this.$parent.activeTab === 1">
    <div class="col-md-6 col-sm-4 mb-3">
      <label for="alert-name" class="form-label">დასახელება</label>
      <input
          type="text"
          class="form-control"
          id="alert-name"
          name="name"
          placeholder="განგაშის დასახელება"
          v-model="this.$parent.alertName"
          :class="{'is-invalid': this.$parent.v$.alertName.$error}"
      />
      <div class="invalid-feedback" v-if="this.$parent.v$.alertName.$error">
        {{ this.$parent.v$.alertName.$errors[0]?.$message }}
      </div>
    </div>
  <div class="col-md-6 col-sm-4 mb-3">
    <label for="alert-type" class="form-label">განგაში </label>
    <KSelect
        :class="{'is-invalid': this.$parent.v$.alertType.$error}"
        v-model="this.$parent.alertType" id="alert-type" placeholder="აირჩიეთ განგაშის ტიპი"
        :options="this.$parent.alertTypes"/>
    <div class="invalid-feedback" v-if="this.$parent.v$.alertType.$error">
      {{ this.$parent.v$.alertType.$errors[0]?.$message }}
    </div>
  </div>
	<template v-if="this.$parent.alertType && type1.includes(this.$parent.alertType)">

<!--		<div class="col-md-6 col-sm-4 mb-3">
			<label for="alert-type" class="form-label">განგაშის შემთხვევა </label>

			<KSelect v-model="this.$parent.alertValues[0]" :options="options" placeholder='აირჩიეთ განგაშის შემთხვევა' />

		</div>-->
    <div class="col-md-6 col-sm-4 mb-3">
      <label for="room-limit" class="form-label">ქვედა ზღვარი</label>
      <input :class="{'is-invalid': this.$parent.v$.alertValues.lowerLimit.$error}" type="number" class="form-control" id="alert-lower-limit" placeholder="შეავსეთ ქვედა ზღვარი მაგ: 0" name="name" v-model="this.$parent.alertValues.lowerLimit">
      <div class="invalid-feedback" v-if="this.$parent.v$.alertValues.lowerLimit.$error">
        {{ this.$parent.v$.alertValues.lowerLimit.$errors[0]?.$message }}
        {{ this.$parent.v$.alertValues.lowerLimit.$errors[1]?.$message }}
      </div>
    </div>

		<div class="col-md-6 col-sm-4 mb-3">
			<label for="room-limit" class="form-label">ზედა ზღვარი</label>
			<input :class="{'is-invalid': this.$parent.v$.alertValues.limit.$error}" type="number" class="form-control" id="alert-limit" placeholder="შეავსეთ ზედა ზღვარი მაგ: 10" name="name" v-model="this.$parent.alertValues.limit">
      <div class="invalid-feedback" v-if="this.$parent.v$.alertValues.limit.$error">
        {{ this.$parent.v$.alertValues.limit.$errors[0]?.$message }}
      </div>
    </div>

		<div class="col-md-6 col-sm-4 mb-3">
			<label for="alertTime" class="form-label">გადაჭარბების დაშვებული დრო (წუთი)</label>
			<input :class="{'is-invalid': this.$parent.v$.alertValues.time.$error}" type="number" class="form-control" id="alert-time" name="name" placeholder='შეავსეთ დაშვებული დრო მაგ: 10 ' v-model="this.$parent.alertValues.time">
      <div class="invalid-feedback" v-if="this.$parent.v$.alertValues.time.$error">
        {{ this.$parent.v$.alertValues.time.$errors[0]?.$message }}
      </div>
    </div>
	</template>

	<template v-if="this.$parent.alertType && type2.includes(this.$parent.alertType)">

		<div class="col-md-6 col-sm-4 mb-3">
			<label for="alertTime" class="form-label">კავშირის დაკარგვის დრო (წუთი)</label>
			<input :class="{'is-invalid': this.$parent.v$.alertValues.lossTime.$error}" type="number" class="form-control" id="alert-time" name="name" placeholder='შეავსეთ დაშვებული დრო მაგ: 10 ' v-model="this.$parent.alertValues.lossTime">
      <div class="invalid-feedback" v-if="this.$parent.v$.alertValues.lossTime.$error">
        {{ this.$parent.v$.alertValues.lossTime.$errors[0]?.$message }}
      </div>
    </div>
	</template>

  </div>
</template>

<script>
import KSelect from "@/components/custom/KSelect";
export default {
	name: "Tab1",
	components: {KSelect},
	data() {
		const type1 = [11,28]
		const type2 = [15,31]
		return {
			type1,
			type2,
			test: null
		}
	},

	computed:{
		options(){
			if (this.$parent.alertType == 11){
				return [{label:'ტემპერატურის აწევისას',value:1},{label:'ტემპერატურის დაწევისას',value:0}]
			}
			if (this.$parent.alertType == 28){
				return [{label:'ტენიანობის აწევისას',value:1},{label:'ტენიანობის დაწევისას',value:0}]
			}
			return []
		}

	}
}
</script>